<div>
  <input #fileUploader type="file" [ngStyle]="{display: 'none'}" (change)="handleFileSelected()">
  <raised-button [color]="buttonColor" (click)="selectFile()" [styles]="{ width: '100%' }">
    @if (showIcon) {
      <i class="far fa-image"></i>
    }
    {{ buttonText }}
  </raised-button>
</div>
